module.exports = __webpack_public_path__ + "img/ptnl-4.fddf1db8.png";